import { render, staticRenderFns } from "./StepInputDuration.vue?vue&type=template&id=0c8ef1a8&"
import script from "./StepInputDuration.vue?vue&type=script&lang=ts&"
export * from "./StepInputDuration.vue?vue&type=script&lang=ts&"
import style0 from "./StepInputDuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports